<template>
  <div :class="`BgSplashCard ${addNew && 'BgSplashCard--add-new'}`">
    <div v-if="addNew" class="BgSplashCard__add-new">
      <div :class="`BgSplashCard__content BgSplashCard__content--create-new`">
        <bg-icon name="close" class="BgSplashCard__new-icon" />
        <div>Create new test</div>
      </div>
    </div>
    <div class="BgSplashCard__icon">
      <img class="BgSplashCard__src" :src="placeholders[platform]" />
    </div>
    <div :class="`BgSplashCard__content BgSplashCard__content--${status}`">
      <div class="BgSplashCard__header">
        <div class="BgSplashCard__title">{{ title }}</div>
        <div class="BgSplashCard__byline">{{ byline }}</div>
      </div>
      <div class="BgSplashCard__footer">
        <div class="BgSplashCard__status">
          <bg-filter-bubble
            class="filter"
            :text="statusText"
            :variant="status"
          />
        </div>
        <div class="BgSplashCard__date">
          <div class="BgSplashCard__pricing">{{ pricingPlan }}</div>
          <div class="BgSplashCard__pricing">{{ name }}</div>
          Updated on {{ date }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import BgFilterBubble from "@/components/bg-filter-bubble";
export default {
  name: "BgSplashCard",
  data() {
    return {
      placeholders: {
        mobile: require("@/assets/imgs/placeholder_mobile.svg"),
        desktop: require("@/assets/imgs/placeholder_desktop.svg"),
        both: require("@/assets/imgs/placeholder_both.svg"),
        all: require("@/assets/imgs/placeholder_all.svg"),
        video: require("@/assets/imgs/placeholder_video.svg"),
      },
    };
  },
  components: {
    BgIcon,
    BgFilterBubble,
    BgIcon,
  },
  props: {
    title: String,
    byline: String,
    status: String,
    date: String,
    name: String,
    statusText: String,
    addNew: Boolean,
    pricingPlan: String,
    platform: {
      type: String,
      default: "all",
    },
  },
};
</script>
